import { SnapchatStandardEvents } from '@xyo-network/sdk-xyo-react-js';
class SnapchatEvents extends SnapchatStandardEvents {
}
export default SnapchatEvents;
//# sourceMappingURL=index.js.map